export * as Api from './api';
export * as Schema from './schema';

export enum InvestorCertificationQuestionType {
  Checkbox = 'CHECKBOX',
  Radio = 'RADIO',
  Text = 'TEXT',
}
